export default class Scroll {
  static forVisibleElement (target, additionalSpace = 20) {
    const dropdownTopOffset = target.getBoundingClientRect().top + additionalSpace
    const position = target.clientHeight + dropdownTopOffset

    if (window.innerHeight < position) {
      window.scrollBy(0, position - window.innerHeight)
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/Scroll.js